import React, { useState } from 'react';
import { Button } from 'semantic-ui-react';
import DemoDeviceFormModal from './DemoDeviceFormModal';
import { addDemoDevice } from '../../../apis/demo.api';

const AddDeviceButton = () => {
  const [open, setOpen] = useState(false);

  const handleSubmit = async ({ macAddress, model, memo }) => {
    try {
      await addDemoDevice({ macAddress, model, memo });
      setOpen(false);
      window.location.reload();
    } catch (error) {
      console.error(error);
      alert('데모기기 추가에 실패했습니다.');
    }
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button icon="plus" onClick={() => setOpen(true)} label="Add Device" />
      </div>
      <DemoDeviceFormModal
        open={open}
        onClose={() => setOpen(false)}
        onSubmit={handleSubmit}
        initialValues={{}}
      />
    </>
  );
};

export default AddDeviceButton;
